// SEQ=10124 P8-CK-H — Bishop UX 모달
// 사양: SEQ-10119 §3-3 #1 + SEQ-10123 §1-2 #1
//   ── 도적이 이동한 hex의 인접 vertex 점유자(자원 ≥1 보유자)를 클라가 사전 집계 →
//      victims 후보 0/1/N 분기 + 다중 약탈 (Bishop = 인접 전원 약탈, KNIGHT 단일과 다름)
//
// 본 모달은 hex 선택 직후 진입 (Play.tsx ActionMode = 'progressCard:POL_BISHOP_VICTIMS')
// hex 선택은 Play.tsx의 보드 클릭 dispatch (ActionMode = 'progressCard:POL_BISHOP_PICK_HEX')가 처리.
// 본 모달은 hex 확정 후 인접 점유자 일람 표시 + 사용자가 "확인" 시 SignalR invoke.
//
// 사용자 선택 UX 결정 (사양 §3-1): Bishop은 인접 전원 자동 약탈(victim 개별 pick 아님).
// 따라서 본 모달은 "victim 명단 노출 + 확인" 단순 UI.
import { CatanPlayer } from '../../store/catan'

export interface BishopVictimModalProps {
  /** 도적이 이동한 hex_id */
  hexId: number
  /** 사전 집계된 인접 자원 보유 점유자 user_code 리스트 */
  victims: number[]
  /** 매치 전 플레이어 정보 (닉네임 lookup용) */
  players: CatanPlayer[]
  /** 사용자가 확인 → SignalR invoke (Play.tsx에서 catanHub.useProgressCard 호출) */
  onConfirm: () => void
  /** 사용자가 취소 → ActionMode rollback */
  onCancel:  () => void
  /** invoke 진행 중 잠금 */
  busy?:     boolean
}

export default function BishopVictimModal({
  hexId, victims, players, onConfirm, onCancel, busy,
}: BishopVictimModalProps) {
  const nick = (uc: number) =>
    players.find(p => p.userCode === uc)?.nickname ?? `유저 ${uc}`

  return (
    <div className="modal-backdrop" style={backdrop} onClick={busy ? undefined : onCancel}>
      <div className="modal-card" style={card} onClick={e => e.stopPropagation()}>
        <h3 style={title}>👑 주교 (Bishop) — 약탈 대상 확인</h3>
        <div style={body}>
          <div>도적 이동 위치 hex #{hexId}.</div>
          <div style={{ marginTop: 6 }}>
            {victims.length === 0
              ? '인접한 자원 보유자가 없습니다 (도적만 이동).'
              : `인접 점유자 ${victims.length}명에서 각 1장씩 자원을 약탈합니다.`}
          </div>
          {victims.length > 0 && (
            <ul style={list}>
              {victims.map(uc => (
                <li key={uc} style={item}>{nick(uc)}</li>
              ))}
            </ul>
          )}
        </div>
        <div style={footer}>
          <button onClick={onCancel}  disabled={busy} style={btnSec}>취소</button>
          <button onClick={onConfirm} disabled={busy} style={btnPri}>확인</button>
        </div>
      </div>
    </div>
  )
}

// ── 스타일 (인라인 — 다른 모달과 톤 일치) ─────────────────────
const backdrop: React.CSSProperties = {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
}
const card: React.CSSProperties = {
  background: '#fff', padding: 16, borderRadius: 6, minWidth: 280, maxWidth: 480,
  boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
}
const title:  React.CSSProperties = { margin: '0 0 10px 0', fontSize: 16 }
const body:   React.CSSProperties = { fontSize: 13, marginBottom: 12 }
const list:   React.CSSProperties = { margin: '6px 0 0 18px', padding: 0 }
const item:   React.CSSProperties = { fontSize: 13 }
const footer: React.CSSProperties = { display: 'flex', justifyContent: 'flex-end', gap: 8 }
const btnPri: React.CSSProperties = { padding: '6px 14px', background: '#1976D2', color: '#fff', border: 'none', borderRadius: 3, cursor: 'pointer' }
const btnSec: React.CSSProperties = { padding: '6px 14px', background: '#eee', color: '#333', border: '1px solid #aaa', borderRadius: 3, cursor: 'pointer' }
